module.exports = __webpack_public_path__ + "static/media/sbp.8b546fa6.pdf";